class GPSProviderTelematicProfileModel extends App.Models.BaseModel {
  modelUrl = 'GPSProviderTelematicProfile';
}

App.Models.GPSProviderTelematicProfile = GPSProviderTelematicProfileModel;
